import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function TryIcon(props: IconProps) {
    return <Icon {...props} iconKey={"try"}/>
}
